(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eyn-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eyn-bundle-builder')) {
    customElements.define('eyn-bundle-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.items = new Map();
        this.purchase = 'once';
        this.limit = Number(this.dataset.limit);
        this.strings = JSON.parse(this.querySelector('[data-builder-strings]').textContent);
        this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency});
        this.addEventListener('click', event => {
          const add = event.target.closest('[data-builder-add]');
          if (add) this.addProduct(add.closest('[data-builder-card]'));
          const control = event.target.closest('[data-builder-action]');
          if (control) this.changeItem(control.dataset.id, control.dataset.builderAction);
          if (event.target.closest('[data-builder-submit]')) this.submit();
        });
        this.addEventListener('change', event => {
          if (event.target.matches('[data-builder-purchase]')) {this.purchase = event.target.value;this.render();return;}
          if (event.target.matches('[data-builder-schedule]')) {this.planId = event.target.value;this.render();return;}
          if (!event.target.matches('[data-builder-variant]')) return;
          const option = event.target.selectedOptions[0];
          event.target.closest('[data-builder-card]').querySelector('[data-card-price]').textContent = this.money(Number(option.dataset.price));
          this.render();
        });
        this.render();
      }
      money(cents) { return this.format.format(cents / 100); }
      count() { return [...this.items.values()].reduce((sum,item) => sum + item.quantity,0); }
      addProduct(card) {
        if (this.busy || this.locked || this.count() >= this.limit) return;
        const option = card.querySelector('[data-builder-variant]').selectedOptions[0];
        if (!option || option.disabled) return;
        const current = this.items.get(option.value);
        if (current) current.quantity += 1;
        else this.items.set(option.value, {id:option.value,title:card.dataset.title,variant:option.dataset.label,image:option.dataset.image,price:Number(option.dataset.price),plans:JSON.parse(option.dataset.plans).filter(plan=>plan.recurring),quantity:1});
        this.render();
      }
      changeItem(id, action) {
        if (this.busy || this.locked) return;
        const item = this.items.get(id);
        if (!item) return;
        if (action === 'remove') this.items.delete(id);
        else if (action === 'increase' && this.count() < this.limit) item.quantity++;
        else if (action === 'decrease') {item.quantity--;if (!item.quantity) this.items.delete(id);}
        this.render();
      }
      makeButton(text,action,id,label) {
        const button = document.createElement('button');
        button.type = 'button';button.textContent = text;button.dataset.builderAction = action;button.dataset.id = id;
        button.setAttribute('aria-label',label);button.disabled = Boolean(this.busy || this.locked || (action === 'increase' && this.count() >= this.limit));
        return button;
      }
      render() {
        const active = document.activeElement;
        const focusControl = this.contains(active) && active.dataset.builderAction ? {action:active.dataset.builderAction,id:active.dataset.id} : null;
        const list = this.querySelector('[data-builder-selected]');list.replaceChildren();
        const count = this.count();let total = 0;
        const items = [...this.items.values()];
        const common = items.length ? items[0].plans.filter(plan => items.every(item=>item.plans.some(p=>String(p.id)===String(plan.id)))) : [];
        if (!common.some(plan=>String(plan.id)===this.planId)) this.planId = common.length ? String(common[0].id) : '';
        if (!common.length) this.purchase = 'once';
        const subscribed = this.purchase === 'subscribe';
        const chosen = common.find(plan=>String(plan.id)===this.planId);
        const regularTotal = items.reduce((sum,item)=>sum+item.price*item.quantity,0);
        const subscriptionTotal = chosen ? items.reduce((sum,item)=>sum+item.plans.find(plan=>String(plan.id)===this.planId).price*item.quantity,0) : regularTotal;
        const saving = regularTotal - subscriptionTotal;
        this.querySelector('[data-builder-once-price]').textContent = count ? this.money(regularTotal) : '';
        this.querySelector('[data-builder-sub-price]').textContent = count && chosen ? this.money(subscriptionTotal) : '';
        this.querySelector('[data-builder-saving-label]').textContent = chosen && saving>0 ? '· '+Math.round(saving/regularTotal*100)+'%' : '';
        this.querySelector('[data-builder-subscription-note]').textContent = !count ? this.strings.select_for_subscription : (chosen ? chosen.name : this.strings.not_eligible);
        const schedule = this.querySelector('[data-builder-schedule]');schedule.replaceChildren();
        for (const plan of common) {const option=document.createElement('option');option.value=String(plan.id);option.textContent=plan.name;option.selected=option.value===this.planId;schedule.append(option);}
        schedule.hidden = !subscribed || common.length<2;
        schedule.disabled = Boolean(this.busy || this.locked);
        this.querySelector('[data-builder-schedule-label]').hidden=schedule.hidden;
        for (const radio of this.querySelectorAll('[data-builder-purchase]')) {radio.checked=radio.value===this.purchase;radio.disabled=Boolean(this.busy || this.locked || (radio.value==='subscribe'&&!common.length));}
        this.querySelector('[data-builder-total-label]').textContent=subscribed?this.strings.recurring_total:this.strings.total;
        this.querySelector('[data-builder-pricing-note]').hidden=subscribed;
        this.querySelector('[data-builder-renewal]').hidden=!subscribed;
        this.querySelector('[data-builder-savings]').hidden=!subscribed||saving<=0;
        this.querySelector('[data-builder-savings]').textContent=this.strings.save+' '+this.money(saving);
        for (const item of this.items.values()) {
          const price = subscribed ? item.plans.find(plan=>String(plan.id)===this.planId).price : item.price;
          total += price * item.quantity;
          const li = document.createElement('li'),image = document.createElement('img'),body = document.createElement('div'),title = document.createElement('strong'),detail = document.createElement('small'),controls = document.createElement('div');
          image.src = item.image;image.alt = '';image.loading = 'lazy';title.textContent = item.title;
          detail.textContent = (item.variant === 'Default Title' ? '' : item.variant + ' · ') + this.money(price * item.quantity);
          controls.className = 'eyn-builder__controls';
          const qty = document.createElement('span');qty.textContent = String(item.quantity);qty.setAttribute('aria-label',this.strings.quantity);
          const remove = this.makeButton(this.strings.remove,'remove',item.id,this.strings.remove + ' ' + item.title);remove.className = 'eyn-builder__remove';
          controls.append(this.makeButton('−','decrease',item.id,this.strings.decrease + ' ' + item.title),qty,this.makeButton('+','increase',item.id,this.strings.increase + ' ' + item.title),remove);
          body.append(title,detail,controls);li.append(image,body);list.append(li);
        }
        this.querySelector('[data-builder-empty]').hidden = count > 0;
        this.querySelector('[data-builder-total]').textContent = this.money(total);
        this.querySelector('[data-builder-mobile-total]').textContent = this.money(total);
        this.querySelector('.eyn-builder__mobile-review').hidden = !count;
        this.querySelector('[data-builder-count]').textContent = count + ' / ' + this.limit + ' · ' + this.strings.limit;
        this.querySelector('[data-builder-submit]').disabled = !count || Boolean(this.busy || this.locked);
        for (const card of this.querySelectorAll('[data-builder-card]')) {
          const option = card.querySelector('[data-builder-variant]').selectedOptions[0],button = card.querySelector('[data-builder-add]');
          const item = option && this.items.get(option.value);
          const cardPlans = option ? JSON.parse(option.dataset.plans).filter(plan => plan.recurring) : [];
          const subscriptionPrice = card.querySelector('[data-card-subscription]');
          subscriptionPrice.hidden = !cardPlans.length;
          subscriptionPrice.textContent = cardPlans.length ? this.strings.subscription_from + ' ' + this.money(Math.min(...cardPlans.map(plan => plan.price))) : '';
          button.textContent = item ? this.strings.added + ' (' + item.quantity + ')' : this.strings.add;
          button.disabled = !option || option.disabled || count >= this.limit || Boolean(this.busy || this.locked);
          card.querySelector('select').disabled = Boolean(this.busy || this.locked);
        }
        if (focusControl) {
          const target = [...this.querySelectorAll('[data-builder-action]')].find(button => button.dataset.id === focusControl.id && button.dataset.builderAction === focusControl.action);
          (target || this.querySelector('[data-builder-submit]:not(:disabled)') || this.querySelector('[data-builder-add]:not(:disabled)'))?.focus();
        }
      }
      async submit() {
        if (this.busy || this.locked || !this.count()) return;
        this.busy = true;this.render();
        const status = this.querySelector('[data-builder-status]');status.textContent = this.strings.adding;
        try {
          const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[...this.items.values()].map(item=>({id:item.id,quantity:item.quantity,...(this.purchase==='subscribe'?{selling_plan:this.planId}:{})}))})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || this.strings.error);
          this.locked = true;
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.locked = true;status.textContent = this.strings.error;
          this.querySelector('[data-builder-view-cart]').hidden = false;
        } finally {this.busy = false;this.render();}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-eco-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click", function(event) {
  const button = event.target.closest(".section-faq .faq-penal > .faq-title");
  if (!button) return;
  const section = button.closest(".section-faq");
  const shouldOpen = button.getAttribute("aria-expanded") !== "true";
  section.querySelectorAll(".faq-penal > .faq-title").forEach(function(title) {
    const open = title === button && shouldOpen;
    title.setAttribute("aria-expanded", String(open));
    title.classList.toggle("active", open);
    title.parentElement.classList.toggle("active", open);
    title.nextElementSibling.style.display = open ? "block" : "none";
    const icon = title.querySelector("i");
    if (icon) {
      icon.classList.toggle("fa-minus", open);
      icon.classList.toggle("fa-plus", !open);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
